export default __webpack_public_path__ + "static/media/flag-green.65814ddc.svg";